import authFetch from './fetch';

export const routes = {
  currentUserPath: () => 'api/me',
  currentUserHeapPath: () => 'api/me/heap',
};

export const fetchCurrentUser = () => authFetch.get(routes.currentUserPath());

export const fetchCurrentUserHeap = () => authFetch.get(routes.currentUserHeapPath());